import { GameState, GlobalState } from "./shared/util/GlobalState";
import { soundManager } from "./shared/UI/SoundManager";
import MathUtils from "./shared/util/MathUtils";
import { SoundInstance } from "./shared/UI/SoundManagerUtils";

class GameStateSoundManager {
    private static _instance: GameStateSoundManager;

    private _musicMain: SoundInstance = new SoundInstance();
    private _musicBonus: SoundInstance = new SoundInstance();

    public get musicMain(): SoundInstance {
        return this._musicMain;
    }
    public get musicBonus(): SoundInstance {
        return this._musicBonus;
    }

    public constructor() {
        document.addEventListener("BONUS_START", () => { this.updateBgMusic('bonusStart'); });
        document.addEventListener("BONUS_END", () => { this.updateBgMusic('bonusEnd'); });
    }

    public static getInstance(): GameStateSoundManager {
        if (!GameStateSoundManager._instance) {
            GameStateSoundManager._instance = new GameStateSoundManager();
        }
        return GameStateSoundManager._instance;
    }

    public updateBgMusicVolume(volume?: number): void {
        switch (GlobalState.getInstance().state) {
            case GameState.MAIN:
                volume = MathUtils.clamp(volume ?? this._musicMain.getBaseVolume(), 0, 1);
                soundManager.setSoundInstanceVolume(this._musicMain, volume);
                break;
            case GameState.BONUS:
                volume = MathUtils.clamp(volume ?? this._musicBonus.getBaseVolume(), 0, 1);
                soundManager.setSoundInstanceVolume(this._musicBonus, volume);
                break;
        }
    }

    public async updateBgMusic(command: 'gameStart' | 'bonusStart' | 'bonusEnd'): Promise<void> {
        switch (command) {
            case 'gameStart':
            case 'bonusEnd':
                console.log("Ended Bonus");

                if (this._musicBonus.tryGetMediaInstance()) {
                    soundManager.stopSoundInstance(this._musicBonus);
                    this._musicBonus.reset();
                }

                const musicMain: SoundInstance | undefined = await soundManager.playSound("musicMainLoop");
                if (musicMain) {
                    this._musicMain = musicMain;
                }

                break;
            case 'bonusStart':
                console.log("Started Bonus");

                if (this._musicMain.tryGetMediaInstance()) {
                    soundManager.stopSoundInstance(this._musicMain);
                    this._musicMain.reset();
                }

                const musicBonus: SoundInstance | undefined = await soundManager.playSound("freeSpinLoop");
                if (musicBonus) {
                    this._musicBonus = musicBonus;
                }

                await soundManager.playSound("bonusCollect");

                break;
        }
    }
}

export const gameStateSoundManager = GameStateSoundManager.getInstance();

